import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function CountdownBanner() {
  return <div className="sticky top-0 z-50 bg-gold text-charcoal py-3 px-4 md:px-6 flex items-center justify-center gap-2 sm:gap-3 shadow-md" data-id="element-50">
      <SparklesIcon className="w-4 h-4 fill-charcoal flex-shrink-0" aria-hidden="true" data-id="element-51" />
      <span className="text-xs sm:text-sm font-semibold tracking-wide text-center" data-id="element-52">
        Acceso especial disponible por tiempo limitado
      </span>
      <SparklesIcon className="w-4 h-4 fill-charcoal flex-shrink-0 hidden sm:inline-block" aria-hidden="true" data-id="element-53" />
    </div>;
}